import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactSelectAdapter from "./ReactSelectAdapter";

export default class ParentDistrictSelect extends Component {

    static propTypes = {
        name: PropTypes.string,
        defaultOptionLabel: PropTypes.string,
        options: PropTypes.array,
        selectedOption: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        selectedParent: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        onChange: PropTypes.func,
        hasSpecialIcon: PropTypes.bool
    };

	render() {
        const {name, defaultOptionLabel, options, selectedOption, selectedParent, onChange, hasSpecialIcon} = this.props;

        const castSelectedOption = isNaN(selectedOption) ? selectedOption : parseInt(selectedOption, 10);
        const castSelectedParent = isNaN(selectedParent) ? selectedParent : parseInt(selectedParent, 10);

        const availableOptions = options.filter(item => item.travelArea === castSelectedParent);

        return (
			<React.Fragment>
                {castSelectedParent !== 0 && availableOptions.length > 0 &&
                <div className={'selectCustom'}>
                    <ReactSelectAdapter
                        selectedOption={castSelectedOption}
                        name={name}
                        options={availableOptions}
                        onChange={onChange}
                        defaultOptionLabel={defaultOptionLabel}
                        hasSpecialIcon={hasSpecialIcon}
                    />
                </div>
                }
            </React.Fragment>
		);
	}
}

ParentDistrictSelect.defaultProps = {
    disabled: false,
};



// WEBPACK FOOTER //
// ./src/components/Planner/ParentDistrictSelect.js